var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature"},[_c('p',{staticClass:"number"},[_vm._t("number")],2),_c('p',{staticClass:"description"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }